<script setup>
import { ref, onMounted } from 'vue'

const video = ref(null)
const lowPowerMode = ref(false)

onMounted(() => {
	video.value.addEventListener('suspend', () => {
		lowPowerMode.value = true
	})
})
</script>

<template>
	<img v-if="lowPowerMode" class="h-72 mix-blend-lighten lg:h-96" src="https://cdn.papercrowns.com/website/video/loading/coin.gif" alt="Coin Spinning Loading Animation" />
	<video v-else class="h-72 mix-blend-lighten lg:h-96" src="https://cdn.papercrowns.com/website/video/loading/coin-spin.mp4" autoplay muted loop playsinline ref="video" />
</template>
